export const MATCH_EVIDENCE_COLORS = [
  '#2563EB',
  '#7C3AED',
  '#10B981',
  '#F59E0B',
  '#EF4444',
  '#6366F1',
  '#14B8A6',
  '#F97316',
  '#EC4899',
  '#0EA5E9',
  '#22C55E',
  '#A855F7',
  '#FACC15',
  '#FB7185',
  '#2DD4BF',
  '#C084FC',
  '#FBBF24',
  '#38BDF8',
  '#F472B6',
  '#4ADE80',
]

export const buildColorMap = (keys: string[], palette: string[] = MATCH_EVIDENCE_COLORS) => {
  const map: Record<string, string> = {}
  keys.forEach((key, index) => {
    const trimmed = key.trim()
    if (!trimmed) return
    if (map[trimmed]) return
    const color = palette[index % palette.length]
    map[trimmed] = color
  })
  return map
}

export const resolveColor = (
  key: string,
  providedMap: Record<string, string> | undefined,
  fallbackPalette: string[] = MATCH_EVIDENCE_COLORS,
  fallbackIndex: number = 0,
) => {
  const trimmed = key.trim()
  if (trimmed && providedMap && providedMap[trimmed]) {
    return providedMap[trimmed]
  }
  if (!fallbackPalette.length) {
    return '#9CA3AF'
  }
  return fallbackPalette[fallbackIndex % fallbackPalette.length]
}
